import { Action } from '@ngrx/store';
import { Offer } from '@rd/types/offer.type';

export enum OfferLocationActionTypes {
  SHOW_OFFER_LOCATIONS = '[Offer] Show Offer Locations',
}

export class ShowOfferLocations implements Action {
  readonly type = OfferLocationActionTypes.SHOW_OFFER_LOCATIONS;

  constructor(public payload: Offer) {}
}

export type OfferLocationActions = ShowOfferLocations;
